import { connect } from 'react-redux';

import LearningAdminModuleAddScreen from '../components/LearningAdminModuleAddScreen';
import storage from '../../../../../lib/Storage';
import { findStorageType } from '../../../../../lib/Auth';

const mapStateToProps = (state) => {
  return {
    partnershipId: storage.get(findStorageType(), 'partnershipId'),
    partnershipName: storage.get(findStorageType(), 'partnershipName'),
    role: storage.get(findStorageType(), 'partnershipData')?.role,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

const LearningAdminModuleAddScreenContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(LearningAdminModuleAddScreen);

export default LearningAdminModuleAddScreenContainer;
